import { createContext, useContext, useMemo, type ReactNode } from "react";

/**
 * Gespeicherter Einklappzustand der Formularabschnitte je Konto (Ronny, 19.10.2026): Jede App speichert
 * ihn je Nutzer und Stelle in ihrer Datenbank. `undefined` = an dieser Stelle noch nie umgeschaltet.
 * Abschnitte ohne gespeicherten Zustand sind die Ausnahme (Lint `form-section-collapse`).
 */
export interface FormSectionCollapseStore {
  isCollapsed: (sectionKey: string) => boolean | undefined;
  setCollapsed: (sectionKey: string, collapsed: boolean) => void;
}

const FormSectionCollapseContext = createContext<FormSectionCollapseStore | null>(null);

/** Einmal an der App-Wurzel; das Produkt liefert nur Laden und Speichern. */
export function FormSectionCollapseProvider({ store, children }: { store: FormSectionCollapseStore; children: ReactNode }) {
  return <FormSectionCollapseContext.Provider value={store}>{children}</FormSectionCollapseContext.Provider>;
}

export function useFormSectionCollapseStore(): FormSectionCollapseStore | null {
  return useContext(FormSectionCollapseContext);
}

/** Speicher aus der Kontopräferenz `Schlüssel → eingeklappt`; `save` schreibt einen einzelnen Abschnitt. */
export function useRecordFormSectionCollapseStore(
  sections: Readonly<Record<string, boolean>> | undefined,
  save: (sectionKey: string, collapsed: boolean) => void,
): FormSectionCollapseStore {
  return useMemo(() => ({ isCollapsed: sectionKey => sections?.[sectionKey], setCollapsed: save }), [sections, save]);
}
